require('lightgallery');
require('lightgallery/src/css/lightgallery.css')

/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

//window.Vue = require('vue');

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

//Vue.component('example-component', require('./components/ExampleComponent.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

/*
const app = new Vue({
    el: '#app',
});

 */

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

function showEntranceModal() {
    $('#entrance-modal').show();
    setTimeout(function () {
        $('#entrance-modal').addClass('md_show');
    },100);
}

function processJobs() {
    let event_subscribe_id = sessionStorage.getItem('event-subscribe-job');
    console.log(typeof event_subscribe_id);
    const container = $('#event-list-container')
    if(typeof event_subscribe_id == 'string' && event_subscribe_id!='void') {
        $.post('/event-subscribe', {event_id:event_subscribe_id}, function ( data ) {
            if(data) {
                if(data.result=='success') {
                    const offset = $('#event-schedule').offset();
                    const body = $("html, body");
                    container.load('/home/event-list', function () {
                        container.children('.loader-line').hide();
                    });
                    body.stop().animate({scrollTop:offset.top - 30}, 300);
                    console.log('vdo6');
                }
                console.log('vdo5');
            }
        },'json');
        console.log('vdo3');
    }
    else {
        container.load('/home/event-list', function () {
            container.children('.loader-line').hide();
        });
        console.log('vdo');
    }

    sessionStorage.setItem('event-subscribe-job','void');

}

function playVideo() {
    const video_container = $('#title-video');
    const video_preview = $('#title-video video').eq(0);
    const height = video_preview.height();
    video_preview.hide();
    video_container.find('iframe').show();
    video_container.find('.video-button').hide();
    $('#video-frame').prop('src','https://www.youtube.com/embed/tcS2TQUCOGY?&autoplay=1').height(height);
}

function playLibraryVideo() {
    var video_info = $('#library-video-info');
    var video_frame = $('#library-video');
    var video_video = video_frame.children('iframe');
    video_info.css('height', video_info.height());
    video_video.css('height',video_frame.width()*0.56);
    setTimeout(function() {
        video_video.show();
        video_info.addClass('md_hide');
        video_frame.css('height',video_frame.width()*0.56);
        setTimeout(function() {
            video_video.prop('src','https://www.youtube.com/embed/J-NZIMjS794?autoplay=1');
        },500);
    },100)
}

$(function() {

    $('.js-play-video').click(function () {
        playVideo();
    });

    $('.js-show-library-video').click(function () {
        playLibraryVideo();
        return false;
    });

    $('.js-goto-video').click(function () {
        const video = $('#title-video');
        if(video.length) {
            const video_top = video.offset().top;
            const body = $("html, body");
            body.stop().animate({scrollTop: video_top - 80}, 300, 'swing', function () {
                playVideo();
            });
        }
        else window.location.href = '/#video-anchor';
    });

    $('.js-show-entrance').click(function () {
        showEntranceModal();
    });

    $('.js-hide-entrance, #entrance-modal').click(function () {
        $('#entrance-modal').hide().removeClass('md_show');
        sessionStorage.setItem('event-subscribe-job','void');
    });

    $('.entrance-window').click(function (e) {
        e.stopPropagation();
    });

    $('.js-scroll-top').click(function () {
        const body = $("html, body");
        body.stop().animate({scrollTop:0}, 300, 'swing');
        $('#layout-up-button').removeClass('md_show');
    });

    let scroll_pending;
    $(window).scroll(function () {
        if(scroll_pending) clearTimeout(scroll_pending);
        scroll_pending = setTimeout(function () {

            if($(window).scrollTop() > 1500) {
                $('#layout-up-button').addClass('md_show');
            }
            else {
                $('#layout-up-button').removeClass('md_show');
            }
        },300);
    });


    $('.js-login').click(function () {
        let email = 'mkir127@gmail.com';
        let password = '123123123'
        let remember = 'on';
        $.post('/login',{email:email, password:password, remember:remember}, function ( data ) {

        },'json');
    });

    $('.js-feedback-proc').click(function () {

        $('#feedback-form').find('input, textarea').removeClass('is-invalid');

        let name = $('#feedback-name-field').val();
        let email = $('#feedback-email-field').val();
        let message = $('#feedback-message-field').val();
        $.post('/feedback', {name:name, email:email, message:message}, function ( data ) {
            if(data.result == 'success') {
                $('#feedback-form > .invalid-feedback').hide();
                $('#feedback-form > .valid-feedback').show();
                $('#feedback-message-field').val('');
            }
            else if(data.result == 'fail') {
                $('#feedback-form > .invalid-feedback').show();
                if(typeof data.errors == 'object') {
                    for(let i in data.errors) {
                        if(data.errors[i]=='name') $('#feedback-name-field').addClass('is-invalid');
                        else if(data.errors[i]=='email') $('#feedback-email-field').addClass('is-invalid');
                        else if(data.errors[i]=='message') $('#feedback-message-field').addClass('is-invalid');
                    }
                }
            }
            else alert('Ошибка F2! Не удалось отправить Ваше сообщение.')
        },'json')
        .fail(function () {
            alert('Ошибка F1! Не удалось отправить Ваше сообщение.')
        });
    });


    $('body').on('click','.js-event-subscribe', function () {
        const _this = $(this);
        console.log('js-event-subscribe');

        if(_this.hasClass('mod_subscribed')) return;

        const event_id = _this.data('event-id');
        $.post('/event-subscribe', {event_id:event_id}, function ( data ) {
            if(data) {
                if(data.result=='login') {
                    sessionStorage.setItem('event-subscribe-job', event_id);
                    showEntranceModal();
                }
                else if(data.result=='success') {
                    _this.addClass('mod_subscribed').html('<svg width="1.8em" height="1.8em" viewBox="0 0 16 16" class="bi bi-check" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z"/></svg> Запланировано');
                }
                else {
                    alert( "Не удалось подписаться на событие" );
                }
            }
        },'json').fail(function() {
            alert( "Не удалось подписаться на событие" );
        });

    });

    function fallbackCopyTextToClipboard(text) {
        var textArea = document.createElement("textarea");
        textArea.value = text;

        // Avoid scrolling to bottom
        textArea.style.top = "0";
        textArea.style.left = "0";
        textArea.style.position = "fixed";

        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        try {
            var successful = document.execCommand('copy');
            var msg = successful ? 'successful' : 'unsuccessful';
        } catch (err) {
            console.error('Fallback: Oops, unable to copy', err);
        }

        document.body.removeChild(textArea);
    }

    function copyTextToClipboard(text) {
        if (!navigator.clipboard) {
            fallbackCopyTextToClipboard(text);
            return;
        }
        navigator.clipboard.writeText(text).then(function() {
        }, function(err) {
            console.error('Async: Could not copy text: ', err);
        });
    }

    $('.js-library-desc-img-zoom').click(function () {
        $('#library-desc-img-zoom-element').click();
    });


    $('.js-library-get-link').click(function (e) {
        const link = $(this).prop('href');
        copyTextToClipboard(link);
        $('.js-library-get-link').show();
        $('.library-items__btt-link-ok').hide().removeClass('mod_animate');
        $(this).hide();
        $(this).siblings('.library-items__btt-link-ok').show(0,function () {
            $(this).addClass('mod_animate');
        });
        e.preventDefault();
        return false;
    });

    $('#event-list-container').on('click', '.js-event-toggle', function () {

        const _this = $(this);
        const item = _this.parents('li');
        const event_id = _this.data('event-id');

        $.post('/event-toggle', {event_id:event_id}, function ( data ) {
            if(data) {
                if(data.result=='success') {
                    if(data.state) {
                        item.removeClass('refused-event');
                        _this.html('Отказаться');
                    }
                    else {
                        item.addClass('refused-event');
                        _this.html('Записаться');
                    }
                }
                else {
                    alert( "Ошибка A2! Не удалось внести изменения." );
                }
            }
        },'json').fail(function() {
            alert( "Ошибка A1! Не удалось внести изменения." );
        });

    });

    $('.js-folders-more').click(function (e) {
       e.stopPropagation();
    });

    $('.js-open-sub-folders').click(function () {
        const parent = $(this).parent('li');
        const collapse = parent.find('.library-tree__collapse').eq(0);
        if(parent.hasClass('mod_opened')) {
            const height = parent.find('.library-tree__sub').eq(0).height()+10;
            collapse.css('height',height);
            parent.removeClass('mod_opened').addClass('mod_close');
            setTimeout(function () {
                collapse.css('height','');
            },100);
            setTimeout(function () {
                parent.removeClass('mod_close')
            },400);
        }
        else {
            parent.addClass('mod_open');
            setTimeout(function () {
                const height = parent.find('.library-tree__sub').eq(0).height()+10;
                collapse.css('height',height);
            },100);
            setTimeout(function () {
                parent.removeClass('mod_open').addClass('mod_opened');
                collapse.css('height','');
            },400);
        }
    });

    if($('#library-items').length) {
        $('#library-items').lightGallery({
            selector: '.library-gallery'
        });
    }


    if(typeof glob_init_page == 'string') {
        if(glob_init_page=='home') {
            processJobs();
        }
        else if(glob_init_page=='register') {
            sessionStorage.setItem('event-subscribe-job','void');
        }
    }


});
